import { Skeleton, SkeletonProps, alpha, styled } from '@mui/material';

interface PrimarySkeletonProps extends SkeletonProps {
  opacity?: number;
}

/**
 * Standard skeleton to be reused across app.
 * @param {number | undefined} opacity Optionally specify a custom opacity for the skeleton clarity.
 * @returns {JSX.Element}
 */
const PrimarySkeleton = styled(Skeleton)<PrimarySkeletonProps>(({ theme, opacity }) => ({
  backgroundColor: alpha(theme.palette.secondary.main, opacity ?? 0.2)
}));

export default PrimarySkeleton;
